import { bucketLog, formattingLogData } from '@bucketplace/bucket-log';
import { type LogFunction, TYPE_MAP } from '@bucketplace/design-system/bds';

import { logAmplitude } from './tracking';

export const handleLog: LogFunction = ({ key, category, params }) => {
  const logData = TYPE_MAP[key](params || {})[category];
  const { bucket, amplitude } = logData || {};

  if (bucket) {
    switch (category) {
      case 'click': {
        bucketLog({
          category: 'click',
          ...bucket,
        });
        break;
      }
      case 'impression': {
        bucketLog({
          category: 'impression',
          data: [
            {
              ...formattingLogData(bucket),
              time: Date.now(),
            },
          ],
        });
        break;
      }
      default:
        break;
    }
  }

  if (amplitude) {
    const { type, data } = amplitude;
    logAmplitude(`${type}`, data);
  }
};
